module.exports = require("core-js/library/fn/object/create");


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-image/~/@babel/runtime/core-js/object/create.js
// module id = 415
// module chunks = 168707334958949